import type { ReactNode } from 'react'
import { MobileTabRow, type MobileTabItem } from './MobileTabs'
import './mobileSubtabs.css'

export interface MobileSubtabBarProps<K extends string = string> {
  items: Array<MobileTabItem<K>>
  activeKey?: K
  onChange: (key: K) => void
  ariaLabel: string
  testId?: string
  compact?: boolean
  slim?: boolean
  variant?: 'pills' | 'underline'
  className?: string
  children?: ReactNode
}

export const MobileSubtabBar = <K extends string = string>({
  items,
  activeKey,
  onChange,
  ariaLabel,
  testId,
  compact = false,
  slim = false,
  variant = 'underline',
  className,
  children,
}: MobileSubtabBarProps<K>) => {
  return (
    <>
      {children ? <div className="mobileSubtabBar__content">{children}</div> : null}
      <div
        className={['mobileSubtabBar', className].filter(Boolean).join(' ')}
        data-testid={testId ? `${testId}-bar` : 'mobile-subtab-bar'}
      >
        <MobileTabRow
          items={items}
          activeKey={activeKey}
          onChange={onChange}
          ariaLabel={ariaLabel}
          testId={testId}
          compact={compact}
          slim={slim}
          variant={variant}
          placement="bottom"
          overflowStrategy="scroll"
        />
      </div>
    </>
  )
}

export default MobileSubtabBar
